export const toAzureLogsInputCreateRequest = ({
  eventHubName,
  connectionString,
  azureName,
  azureThrottleEnabled,
  azureStoreFullMessage,
  contentTypes,
  azureBatchSize,
  proxyOptions,
  enableProxy,
  azureWaitTime,
  pollingInterval,
  consumerGroup
}) => ({
  name: azureName.value,
  polling_interval: pollingInterval.value,
  polling_time_unit: "MINUTES",
  azure_event_hub_name: eventHubName.value,
  enable_throttling: !!(azureThrottleEnabled == null ? void 0 : azureThrottleEnabled.value),
  store_full_message: !!(azureStoreFullMessage == null ? void 0 : azureStoreFullMessage.value),
  content_types: contentTypes.value,
  azure_batch_size: azureBatchSize.value,
  proxy_options: proxyOptions == null ? void 0 : proxyOptions.value,
  enable_proxy: !!(enableProxy == null ? void 0 : enableProxy.value),
  azure_wait_time: azureWaitTime.value,
  azure_connection_string: connectionString.value,
  azure_consumer_group: consumerGroup.value
});
export const toGenericInputCreateRequest = ({
  eventHubName,
  connectionString,
  azureName,
  azureThrottleEnabled,
  contentTypes,
  azureBatchSize,
  proxyOptions,
  enableProxy,
  azureWaitTime,
  pollingInterval,
  consumerGroup
}) => ({
  type: "org.graylog.enterprise.integrations.azure.AzureLogsInput",
  title: azureName.value,
  global: false,
  configuration: {
    polling_interval: pollingInterval.value,
    polling_time_unit: "MINUTES",
    event_hub_name: eventHubName.value,
    throttling_allowed: !!(azureThrottleEnabled == null ? void 0 : azureThrottleEnabled.value),
    content_types: contentTypes.value,
    azure_batch_size: azureBatchSize.value,
    proxy_options: proxyOptions == null ? void 0 : proxyOptions.value,
    enable_proxy: !!(enableProxy == null ? void 0 : enableProxy.value),
    azure_wait_time: azureWaitTime.value,
    connection_string: connectionString.value,
    consumer_group: consumerGroup.value
  }
});
